/**
 * Tiny ambient layer — floating gold sparks for any page.
 * Drop <Sparks /> inside any container that has `position: relative`.
 */
export default function Sparks({ count = 7, className = "" }) {
  return (
    <div className={`gold-sparks ${className}`} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <span key={i} />
      ))}
    </div>
  );
}
